import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiselectAutocompleteComponent } from './multiselect-autocomplete.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';

@NgModule({
    declarations: [MultiselectAutocompleteComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        CustomerPrivacyModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [MultiselectAutocompleteComponent],
})
export class MultiselectAutocompleteModule {}
